import { type ForkEffect, takeEvery } from 'redux-saga/effects';

import {
  ERequestFailedReason,
  type RequestFailedAction,
} from '../../../admin-types';
import { ESessionStatus, SESSION_QUERY_PARAM } from '../user/types';
import { requestFailed } from './reducer';

const PUBLIC_PATHS: readonly string[] = ['/login', '/logout'];

export function redirectToLoginOnUnauthorized(
  action: RequestFailedAction,
): void {
  if (action.payload.reason !== ERequestFailedReason.UNAUTHORIZED) {
    return;
  }

  if (PUBLIC_PATHS.includes(window.location.pathname)) {
    return;
  }

  window.location.assign(
    `/login?${SESSION_QUERY_PARAM}=${ESessionStatus.EXPIRED}`,
  );
}

export function* watch(): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(requestFailed.type, redirectToLoginOnUnauthorized);
}
